import { between } from '@iotv/core-services';
import { rangeColors } from '../../Display/metricRanges';
import { isNumber } from '@iotv/datamodel-core';
const debug = process.env.REACT_APP_DEBUG && false;
/** style reception areas base on  selected metricAttributeKey based on aggregation of all gateways and networks selected */
export const getReceptionAreaStyleFn = (metricAttributeKey) => (feature) => {
    debug && console.log(`FeatureStyles getReceptionAreaStyleFn  with ${metricAttributeKey} has feature`, feature);
    const data = feature.getProperty('data');
    debug && console.log('FeatureStyles getReceptionAreaStyleFn has data', data);
    const strokeColorizer = rangeColors[metricAttributeKey];
    /** 2024 09 29 - network cmvs from actual areas is going onto item.data, but from cells in grids via coverage it is going on item.data.receptionStats  */
    const metricAttributeValue = data?.[metricAttributeKey]?.mean ?? data?.receptionStats?.[metricAttributeKey]?.mean;
    const fillColor = isNumber(metricAttributeValue)
        ? (strokeColorizer.find((colorRange) => between(metricAttributeValue, colorRange[0], colorRange[1]))?.[2] ?? 'black')
        : 'brown';
    const fillOpacity = isNumber(metricAttributeValue) ? 0.8 : 0;
    debug && console.log(`FeatureStyles getReceptionAreaStyleFn setting fillColor to ${fillColor}`, { feature, strokeColorizer, metricAttributeValue });
    return {
        fillColor,
        fillOpacity,
        strokeWeight: 0,
    };
};
export const getGatewayReceptionLineStyleFn = (metricAttributeKey) => (feature) => {
    const data = feature.getProperty('data');
    debug && console.log('FeatureStyles getGatewayReceptionLineStyleFn has data', data);
    const strokeColorizer = rangeColors[metricAttributeKey];
    const metricAttributeValue = data?.[metricAttributeKey]?.mean;
    const strokeColor = isNumber(metricAttributeValue)
        ? (strokeColorizer.find((colorRange) => between(metricAttributeValue, colorRange[0], colorRange[1]))?.[2] ?? 'violet')
        : 'red';
    debug &&
        console.log(`FeatureStyles getGatewayReceptionLineStyleFn made with ${metricAttributeKey} and value ${metricAttributeValue} has feature`, {
            feature,
            strokeColor,
        });
    return {
        strokeWeight: 4,
        strokeOpacity: 0.8,
        strokeColor,
    };
};
